import { Box, Container } from "@chakra-ui/react";

import { Header } from "components";

const HowToUsePage = () => {
  return (
    <>
      <Header />

      <Container maxW="container.lg">
        <Box
          as="h1"
          textAlign="center"
          color="grayTitle"
          fontSize="xl"
          my="1rem"
        >
          How to Use
        </Box>

        <Box color="grayTxt">
          <Box as="p" mb="1rem">
            Entering a word in the search box will allow you to search for its
            meaning and collocates.
          </Box>
          <img src="/images/image1.png" alt="img1" />
          <br />

          <Box as="p" mb="1rem">
            Where multiple POS are possible, you may select from the available
            options:
          </Box>
          <img src="/images/image2.png" alt="img2" />
          <br />

          <Box as="p" mb="1rem">
            There are two tabs, Definitions and Collocates. The Definitions tab
            will give you various definitions of the word which has been
            searched, together with pronunciation (click on the speaker icon),
            and example sentences where available.
          </Box>
          <img src="/images/image3.png" alt="img3" />
          <br />
          <Box as="p" mb="1rem">
            Clicking on this box will display translations of the definitions in
            the selected language. Note: as they are translated, there may be
            some awkward or unusual expressions.
          </Box>
          <img src="/images/image4.png" alt="img4" />
          <br />

          <Box as="p" mb="1rem">
            In this example, the definitions are displayed in Chinese.
          </Box>
          <img src="/images/image5.png" alt="img5" />
          <br />

          <Box as="p" mb="1rem">
            The Collocates tab displays collocates of the target word, in
            descending order of frequency. The dark green column indicates
            whether the collocate appears more frequently before the target
            word, or after it (eg above: "impact" usually appears before "on",
            but after "environmental")
          </Box>
          <img src="/images/image6.png" alt="img6" />
          <br />

          <Box as="p" mb="1rem">
            Clicking on the filter icon will bring up this dialogue box, which
            will allow you to filter the results displayed by specific
            collocate, or by part of speech:
          </Box>
          <img src="/images/image7.png" alt="img7" />
          <br />

          <Box as="p" mb="1rem">
            Filtering by specific words will allow you to see whether those
            words are among the collocates listed for the target word:
          </Box>
          <img src="/images/image8.png" alt="img8" />
          <br />

          <Box as="p" mb="1rem">
            In the example above, "negative" and "positive" are found, but
            "super" is not found
          </Box>
          <img src="/images/image9.png" alt="img9" />
          <br />

          <Box as="p" mb="1rem">
            Filtering by POS will allow you to display only the collocates of
            the target word with that POS:
          </Box>
          <img src="/images/image10.png" alt="img10" />
          <br />

          <Box as="p" mb="1rem">
            In the example above, only adjectives are displayed. The filter icon
            is solid green when any filter is applied.
          </Box>
          <img src="/images/image11.png" alt="img11" />
          <br />
        </Box>
      </Container>
    </>
  );
};

export default HowToUsePage;
